function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.99517 20C15.4761 20 20 15.4739 20 10C20 4.52611 15.4664 0 9.9855 0C4.51426 0 0 4.52611 0 10C0 15.4739 4.52392 20 9.99517 20ZM8.91252 14.7776C8.54519 14.7776 8.24553 14.6228 7.97487 14.265L5.60657 11.3926C5.43258 11.1702 5.34558 10.9478 5.34558 10.706C5.34558 10.2031 5.7419 9.79691 6.24456 9.79691C6.54422 9.79691 6.77622 9.90329 7.02755 10.2224L8.88352 12.5725L12.8661 6.18956C13.0788 5.85106 13.3494 5.68665 13.6588 5.68665C14.1518 5.68665 14.5964 6.02515 14.5964 6.53772C14.5964 6.76015 14.4804 7.00193 14.3451 7.2147L9.8115 14.265C9.59884 14.6035 9.27985 14.7776 8.91252 14.7776Z",
  fill: "#19324D"
});

function SvgCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/Check.a347b6b5.svg";
export { ForwardRef as ReactComponent };